import { mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import AIMEOS_GETTERS from '@/js/plugins/store/modules/aimeos/getter-types/index.js'

export default {
  computed: {
    ...mapGetters(STOREMODULES.AIMEOS, {
      contentBaseurl: AIMEOS_GETTERS.OPTIONS_CONTENT_BASEURL,
    }),
  },
}
